var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("m-confirm", { ref: "confirm", attrs: { mode: "primary" } }),
      _c("m-info", { ref: "info" }),
      _c("div", { staticClass: "layout-header" }, [
        _c("h2", { staticClass: "layout-title" }, [
          _vm._v(_vm._s(_vm.id ? "Редактирование анкеты" : "Новая анкета")),
        ]),
        _c("div", { staticClass: "layout-header-actions" }, [
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button", {
                attrs: {
                  size: "small",
                  responsive: true,
                  icon: "back",
                  type: "with-icon",
                  label: "К списку анкет",
                },
                on: {
                  click: function ($event) {
                    return _vm.$router.push({ name: "profiles" })
                  },
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "layout-content" },
        [
          _c("profile-form", {
            attrs: { "profile-data": _vm.profileData },
            on: { updated: _vm.updateProfileData },
          }),
        ],
        1
      ),
      _vm.id
        ? _c("div", [
            _vm.loading
              ? _c(
                  "div",
                  [
                    _c("c-loader", {
                      attrs: {
                        active: _vm.loading,
                        height: 450,
                        label: "Данные загружаются",
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("c-tabs", {
                      attrs: {
                        active: _vm.activeProfileSection,
                        items: _vm.profileSections,
                      },
                      on: {
                        change: function ($event) {
                          _vm.activeProfileSection = $event
                        },
                      },
                    }),
                    _c("profile-section", {
                      attrs: {
                        "profile-id": _vm.id,
                        "profile-section": _vm.activeProfileSection,
                        "profile-tabs": _vm.tabs,
                      },
                      on: {
                        tabCreated: _vm.addTab,
                        tabUpdated: _vm.updateTab,
                        tabRemoved: _vm.removeTab,
                        tabsResorted: _vm.resortTabs,
                        fieldCreated: _vm.addField,
                        fieldUpdated: _vm.updateField,
                        fieldRemoved: _vm.removeField,
                        fieldMoved: _vm.moveField,
                        copySection: _vm.copySection,
                      },
                    }),
                  ],
                  1
                ),
          ])
        : _vm._e(),
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }